<script setup>
import HarmonyCover from './HarmonyCover.vue';
import HarmonyServiceSelect from './HarmonyServiceSelect.vue';

const props = defineProps({
  ticketCountData: {
    required: true,
  },
  harmonyLogData: {
    required: true,
  },
  hasPermission: {
    required: true,
  },
  loadingTicket: {
    required: true,
  },
});

const emit = defineEmits(['goPopAnalysis']);
</script>

<template>
  <div class="si-overview si-overview--harmony">
    <HarmonyCover
      :ticketCountData="ticketCountData"
      :harmonyLogData="harmonyLogData"
      :hasPermission="hasPermission"
      :loadingTicket="loadingTicket"
    />
    <HarmonyServiceSelect :hasPermission="hasPermission" @goPopAnalysis="emit('goPopAnalysis')" />
  </div>
</template>

<style lang="scss">
@import '@/assets/nangman_style/_saju-insight-overview.scss';
</style>
